export const styles = {
  horizontalTabsSx: (isMobile: boolean) => ({
    px: isMobile ? 0 : 4,
  }),

  horizontalContainer: (bgwhite) => ({
    backgroundColor: bgwhite,
  }),

  verticalContainer: (navbarHeight: number) => ({
   top: navbarHeight,
  }),

  scrollViewVertical: {
    height: "100%",
    overflowY: "auto",
    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },

    "& .MuiTabs-flexContainerVertical": {
      gap: "80px",
      padding: "80px",
    },

    "& .MuiTab-root": {
      minHeight: "48px",
      transition: "all 0.2s ease",
    },
  },
};
